module.exports = __webpack_public_path__ + "static/media/bg-video-embed.857da08e.jpg";